import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Drawer, Primary, Text } from "@cinch-labs/design-system";
import { useSearchAlertFiltersFormatting, useSearchAlerts } from "../../../hooks";
import SearchAlertsForm from "../form";
import styles from "./drawer.module.css";
import { useState } from "react";
const SearchAlertsDrawer = ({ onClose  })=>{
    const [emailFrequency, setEmailFrequency] = useState();
    const { registerSearchAlert , fetchStatus  } = useSearchAlerts();
    const formattedSearchAlertFilters = useSearchAlertFiltersFormatting();
    const isFetchSuccess = fetchStatus === "success";
    const emailFrequencyText = emailFrequency === "1d" ? "every day" : "each week";
    const renderInitialDrawerContent = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    fontSizeFixed: "m",
                    className: styles.drawerBodyCopy,
                    children: "Be the first to know when cars that match what you're looking for become available."
                }),
                /*#__PURE__*/ _jsx(Text, {
                    element: "h2",
                    fontSizeFixed: "m",
                    fontWeight: "bold",
                    className: styles.drawerHeading,
                    children: "Your search alerts"
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fontSizeFixed: "m",
                    className: styles.drawerBodyCopy,
                    children: "We'll send you email alerts for:"
                }),
                /*#__PURE__*/ _jsx("ul", {
                    className: styles.drawerList,
                    children: formattedSearchAlertFilters.map((item)=>/*#__PURE__*/ _jsx(Text, {
                            "aria-label": item.display,
                            className: styles.drawerListItem,
                            element: "li",
                            fontSizeFixed: "s",
                            children: item.display
                        }, item.key))
                }),
                /*#__PURE__*/ _jsx(Text, {
                    children: "These alerts will replace any you have set up previously."
                }),
                /*#__PURE__*/ _jsx(SearchAlertsForm, {
                    fetchStatus: fetchStatus,
                    sendDataToCustomerIo: registerSearchAlert,
                    onFrequencyChanged: setEmailFrequency
                })
            ]
        });
    const renderSuccessDrawerContent = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(Text, {
                    fontSizeFixed: "m",
                    className: styles.successText,
                    "aria-live": "assertive",
                    children: [
                        "Nice one! We'll email you a fresh list of cars ",
                        emailFrequencyText,
                        " ",
                        "if we find ones you're looking for — so you won't miss out."
                    ]
                }),
                /*#__PURE__*/ _jsx(Primary, {
                    isFullWidth: true,
                    onClick: onClose,
                    children: "Continue browsing cars"
                })
            ]
        });
    const drawerHeader = isFetchSuccess ? "Search alerts set up" : "Set up search alerts";
    return /*#__PURE__*/ _jsxs(Drawer, {
        header: drawerHeader,
        onClose: onClose,
        children: [
            !isFetchSuccess && renderInitialDrawerContent(),
            isFetchSuccess && renderSuccessDrawerContent()
        ]
    });
};
export default SearchAlertsDrawer;
